<template>
  <div class="" id="quote">
    <div class="w-container">
      <div class="row">
        <div class="col-sm-10 offset-1">
          <h1>{{ $t("marinConstantin.quote.text") }}</h1>
          <div id="author" v-html="$t('marinConstantin.quote.source')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MCQuote"
};
</script>

<style scoped>
#quote {
  background-color: #061725;
  color: white;
  padding: 7vh 10px;
}

#quote h1 {
  margin-bottom: 31px;
  font-family: Roboto, sans-serif;
  font-size: 3.4em;
  line-height: 1.3em;
  font-weight: 300;
  text-align: center;
}

#author {
  color: #657581;
  font-size: 1.3em;
  text-align: center;
}

@media (max-width: 476px) {
  #quote h1 {
    font-size: 1.8em;
  }

  #author {
    font-size: 1.1em;
  }
}
</style>
